import { FC, ReactElement } from "react";

import { Button, Col, Modal, Row } from "antd";
import { arrayOrEmpty } from "utils";

import { IconButton } from "components/forecasting/Shared";

import { AutomationGroup } from "../types/automation";
import { CommandId } from "../types/topics";

type AddCommandModalProps = {
  open: boolean;
  onCancel?: () => void;
  onAddCommand?: (template: AutomationGroup) => void;
  selectedCommand?: string | null;
  commands?: Array<{
    id: CommandId;
    icon: ReactElement;
    template: AutomationGroup;
  }>;
};

export const AddCommandModal: FC<AddCommandModalProps> = ({
  open,
  onCancel,
  onAddCommand,
  commands
}) => {
  return (
    <Modal
      title="Add Command"
      open={open}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>
      ]}
      width={500}>
      <Row gutter={[12, 12]}>
        {arrayOrEmpty(commands).map((cmd) => {
          return (
            <Col span={7} key={cmd.id}>
              <IconButton
                style={{
                  height: 80,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  width: 120
                }}
                onClick={() => {
                  onAddCommand &&
                    onAddCommand({
                      ...cmd.template
                    });
                }}>
                {cmd.icon}
                <span style={{ fontSize: 12 }}>{cmd.template.name}</span>
              </IconButton>
            </Col>
          );
        })}
      </Row>
    </Modal>
  );
};
